import fetch from "../components/optionsFetch";
﻿import * as React from 'react';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { Button } from '@progress/kendo-react-buttons';
import { GetPermissions } from '../components/Options';
import { useNavigate } from "react-router-dom";
import Notifications from '../components/Notifications';
import configData from "../config.json";
import { GetSession, GetToken } from '../components/Session';
import { DropDownList } from "@progress/kendo-react-dropdowns";

const WeighbridgeSettings = () => {
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState();
    const navigate = useNavigate();
    const [lookupParams, setLookupParams] = React.useState(""); 
    const [groups, setGroups] = React.useState([]);
    const [selectedGroup, setSelectedGroup] = React.useState("All");
    const [layout, setLayout] = React.useState([
        { "field": "searchSite", "label": "Site", "isVisible": true, "type": "list" },
        { "field": "settingsGroup", "label": "Settings Group", "isVisible": true, "type": "list" }
    ]);
    if (localStorage.getItem("userid") === null) navigate("/logout");

    const subTotals = [
        { field: 'name', aggregate: 'count' }
    ];

    if (permissions && !permissions.EditAppSettings) navigate("/error401");
    React.useEffect(() => {
        GetColumnDefs("WeighbridgeSettings", setColumns);
        GetPermissions(["EditAppSettings"], setPermissions);
        let baseUrl = configData.SERVER_URL + "apiv7/options";
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        baseUrl = configData.SERVER_URL + "apiv7/options";
        let ss = localStorage.getItem("SettingsSearch");
        fetch(baseUrl, init).then((response) => response.json()).then((d) => {
            setSites(CreateList(d.sites));
            setGroups(["All", ...d.settingsGroups]);
            setSelectedGroup("All");
            if (ss !== undefined && ss !== "" && ss !== null) {
                let s = d.sites.find(obj => obj.id === ss);
                setSite(s);
                setParams(s, "All");
            } else {
                setSite({ id: "0", name: "All" });
                setLookupParams("");
            }
        });
    }, [])

    const GetField = (f, def = "") => {
        let fld = layout.find(obj => { return obj.field === f });
        if (fld === undefined) return { "field": f, "label": def, "defaultValue": "", "isVisible": true, "type": "text" }
        return fld;
    }
    const siteChanged = (event) => {
        setSite(event.target.value);
        localStorage.setItem("SettingsSearch", event.target.value.id);
        setParams(event.target.value, selectedGroup);
    }

    const CreateList = (d) => {
        var x = [{ id: "0", name: "All" }, {id: "1", name: "Cloud (1)"}];
        d.map((v) => x.push({ id: v.id, name: v.name + " (" + v.id + ")" }));
        return x;
    };

    const SettingsCommand = (item, ev) => {
        var url = `${configData.SERVER_URL}apiv7/settings?id=${item.settingsId}&value=${ev.value}`;
        const init = {
            method: 'PATCH',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
        }
        fetch(url, init);
    }

    const setParams = (site, group) => {
        let id = site === undefined ? 0 : parseInt(site.id);
        let sp = { "SiteId": id, "SearchGroup": group };
        setLookupParams(encodeURI(JSON.stringify(sp)));
    }

    const groupChanged = (e) => {
        setSelectedGroup(e.value);
        setParams(site, e.value);
    }

    return (
        <div>
            <Notifications errorMessage={errorMessage} />
            <div className="row" style={{ padding: "5px 10px" }}>
            {GetField("searchSite")["isVisible"] && <div className="col-md-3">
                <label className="control-label">{GetField("searchSite")["label"]}</label>
                <DropDownList id="Site" data={sites} value={site} textField="name" dataItemKey="id" onChange={siteChanged} />
                </div>}
                {GetField("settingsGroup")["isVisible"] && <div className="col-md-2">
                    <label className="control-label">{GetField("settingsGroup", "Settings Group")["label"]}</label>
                    <DropDownList id="Group" data={groups} value={selectedGroup} onChange={groupChanged} />
                </div>}
            </div>

            <div className="row">
                {columns && permissions && <DataGrid dataSource='apiv7/settings' columns={columns} permissions={permissions} params={lookupParams} keyField="settingsId" customCommand={SettingsCommand} customCommandName="SettingsCommand" />}
            </div>
            <div style={{ padding: "10px" }}>{configData.VERSION} - {configData.VERSION_DATE}</div>
        </div>
    );

}

export default WeighbridgeSettings;